import { StyleRules } from '@material-ui/core/styles';
import { CardClassKey } from '@material-ui/core/Card';

export const MuiCard: Partial<StyleRules<CardClassKey>> = {
  root: {
    boxShadow: 'none',
    backgroundColor: 'initial',
  },
};
